import { render, staticRenderFns } from "./SideEffects.vue?vue&type=template&id=45643b7f"
import script from "./SideEffects.vue?vue&type=script&lang=js"
export * from "./SideEffects.vue?vue&type=script&lang=js"
import style0 from "./SideEffects.vue?vue&type=style&index=0&id=45643b7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports